import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../../app/shared/enums/HttpStatusCodes';
import { GESTION_USUARIOS_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import { errorValidResetUser, successValidResetUser, validResetUser } from '../actions';

@Injectable()
export class ResetUserEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    public validResetUser$ = createEffect(
        () => this.actions$.pipe(
            ofType(validResetUser),
            switchMap(actions => this.httpS.executeRequestByUser(GESTION_USUARIOS_ENDPOINTS.user_reset, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.USUARIOS))
                    .pipe(
                        map(resp => successValidResetUser(resp)),
                        catchError((err: Error) => of(errorValidResetUser({ payload: err })))
                    )
            )
        )
    );

}
